/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { deferUntilEngaged } from './app/utils/deferNonCritical';

import './lcpSlidesPrime';
import store from './app/config/store';
import App from './App';
import { AbilityContext } from './app/config/abilityContext';
import ability from './app/config/ability';
import './index.scss';

const loadDeferredFonts = () => {
  import('./app/assets/stylesheets/settings/_fonts-deferred.scss');
};

if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadDeferredFonts, { timeout: 3000 });
  } else {
    window.setTimeout(loadDeferredFonts, 1500);
  }
}

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_CLARITY_ID) {
  deferUntilEngaged(() => {
    import('react-microsoft-clarity').then(({ clarity }) => {
      clarity.init(process.env.REACT_APP_CLARITY_ID);
    });
  });
}

const app = (
  <Provider store={store}>
    <AbilityContext.Provider value={ability}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </AbilityContext.Provider>
  </Provider>
);
const container = document.getElementById('root');
const root = createRoot(container);
root.render(app);
